import React, { useContext, useEffect, useRef } from "react";
import styles from "./SpyMenu.module.scss";
import StateContext from "../../context/state";
import PathContext from "../../context/path";
const SpyMenu = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const refLinks = useRef([]);
  const refInner = useRef(null);
  const {  isMobile } = state;
  useEffect(() => {
    if(isMobile) return;
    const inner = refInner.current;
    const rem = window.innerWidth * 1.176 / 100;
    const scrollOffsetTop = 5 * rem;
    const scrollLinks = refLinks.current;
    const scrollHandler = () => {
      const scrollTriggers = document.querySelectorAll('[data-scrollspy-trigger]');
      if (scrollTriggers.length === 0) return;
      const array = [...scrollTriggers].filter((element) => element.getBoundingClientRect().bottom >= scrollOffsetTop).map((element) => element.dataset.scrollspyTrigger);
      if (array.length > 0) {
        updateLinks(array);
      }

      const opacityTriggers = document.querySelectorAll('[data-opacity-trigger]');
      let tempOpacityArray = [];
      opacityTriggers.forEach((element) => {
        if(element.getBoundingClientRect().top < inner.getBoundingClientRect().bottom && element.getBoundingClientRect().bottom > inner.getBoundingClientRect().top){
          tempOpacityArray.push(element)
        }
      });
      if(tempOpacityArray.length > 0){
        inner.classList.add(styles.opacity);
      }else{
        inner.classList.remove(styles.opacity);
      }
    }

    const updateLinks = (array) => {
      scrollLinks.forEach((element, index) => {
        if (parseInt(array[0], 10) === index) {
          element.classList.add(styles.active);
        } else {
          element.classList.remove(styles.active);
        }
      });
    }
    scrollHandler();
    document.addEventListener('scroll', scrollHandler);
    return () => {

      document.removeEventListener('scroll', scrollHandler);
    }
  }, [isMobile]);

  const scrollToHandler = (num) => {
    const rem = window.innerWidth * 1.176 / 100;
    const scrollOffsetTop = 5 * rem;
    const trigger = document.querySelector(`[data-scrollspy-trigger='${num}']`);
    if (trigger === null) return;
    const offset = trigger.getBoundingClientRect().top + window.scrollY - scrollOffsetTop;
    window.scrollTo({
      top: offset,
      behavior: "smooth",
    });
  }
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.inner} ref={refInner}>
          <div className={styles.link} ref={element => refLinks.current[0] = element} data-scrollspy-link={0} onClick={() => scrollToHandler(0)}>
            <span>Введение</span>
          </div>
          <div className={styles.link} ref={element => refLinks.current[1] = element} data-scrollspy-link={1} onClick={() => scrollToHandler(1)}>
            <span>Проблема новогодних</span> <span>проектов</span>
          </div>
          <div className={styles.link} ref={element => refLinks.current[2] = element} data-scrollspy-link={2} onClick={() => scrollToHandler(2)}>
            <span>Чем полезен</span> <span>новогодний проект</span>
          </div>
          <div className={styles.link} ref={element => refLinks.current[3] = element} data-scrollspy-link={3} onClick={() => scrollToHandler(3)}>
            <span>Бонус</span>
          </div>
          <div className={styles.link} ref={element => refLinks.current[4] = element} data-scrollspy-link={4} onClick={() => scrollToHandler(4)}>
            <span>Заключение</span>
          </div>
        </div>
      </div>
    </>
  );

}

export default SpyMenu;
